// @flow
/**
 * User: Mike Chung
 * Date: 20/1/2018
 * Time: 8:03 PM
 */
import {lockEBadge} from "../../../dao/eBadgeDao";
import type {
    CloseEBadgeLockModalAction,
    EBadgeLockFailedAction,
    EBadgeLockStartAction,
    EBadgeLockSuccessAction,
    EBadgeLockThunkAction,
    OpenEBadgeLockModalAction
} from "../eBadgeLockAction";
import type {Caller} from "../../../components/QueryPage";
import type {StoreState} from "../../../reducers/combinedReducers";
import * as _ from "lodash";
import EBadge from "../../../model/ebadge/EBadge";


function eBadgeLockStartAction(registrationCode: string): EBadgeLockStartAction {
    return {
        type: "ebadge/LOCK_START_ACTION",
        registrationCode: registrationCode
    };
}

function eBadgeLockSuccessAction(registrationCode: string): EBadgeLockSuccessAction {
    return {
        type: "ebadge/LOCK_SUCCESS_ACTION",
        registrationCode: registrationCode
    }
}

function eBadgeLockFailedAction(error: any, registrationCode: string): EBadgeLockFailedAction {
    return {
        type: "ebadge/LOCK_FAILED_ACTION",
        registrationCode: registrationCode,
        error: Object.assign({}, error)
    }
}

function findFirstBoothNumberByRegistrationCode(state: StoreState, registrationCode: string): ?string {
    const badge: EBadge = _.find(state.eBadgeQuery.eBadges, (eBadge: EBadge) => eBadge.registrationCode === registrationCode);
    const boothNumbers: ?string = _.get(badge, 'boothNumber');
    if (boothNumbers) {
        const firstBoothNumber: ?string = _.chain(boothNumbers).split(',').head().value();
        return firstBoothNumber;
    }
}

export function eBadgeLockAction(registrationCode: string, caller: Caller): EBadgeLockThunkAction {

    return async (dispatch, getState) => {
        try {

            if (getState) {
                dispatch(eBadgeLockStartAction(registrationCode));
                const state: StoreState = getState();
                const firstBoothNumber: ?string = findFirstBoothNumberByRegistrationCode(state, registrationCode);
                await lockEBadge(registrationCode, caller, state.loginUser.jwt, firstBoothNumber);
                dispatch(eBadgeLockSuccessAction(registrationCode));
            } else {
                throw new Error("Unexpected Error");
            }
        } catch (e) {
            dispatch(eBadgeLockFailedAction(e, registrationCode));
        }
    };
}

export function openLockEBadgeModalAction(registrationCode: string): OpenEBadgeLockModalAction {
    return {
        type: "ebadge/SHOW_LOCK_MODAL",
        registrationCode: "" + registrationCode
    }
}

export function closeLockEBadgeModalAction(): CloseEBadgeLockModalAction {
    return {
        type: "ebadge/HIDE_LOCK_MODAL"
    }
}


// WEBPACK FOOTER //
// ./src/actions/ebadge/creators/eBadgeLockActionCreator.js